import { render, staticRenderFns } from "./EvolutionDashboardDepartmentsSelector.vue?vue&type=template&id=ac077582&"
import script from "./EvolutionDashboardDepartmentsSelector.vue?vue&type=script&lang=js&"
export * from "./EvolutionDashboardDepartmentsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports